// The Terms of Use version a sign-up or checkout accepts: the effective date of the text on
// /terms-and-conditions, as YYYY-MM-DD so string order is date order (the checkout write relies on it).
export const TERMS_VERSION = "2026-11-01";

// Wire contract between the sign-up screens and `onSignUp`. The email form sends the param on the
// `/auth/sign-up` request; the Google button sets the cookie, because gemi's OAuth round trip keeps
// no query param of its own.
export const TERMS_VERSION_PARAM = "terms-version";
export const TERMS_SEEN_COOKIE = "folio_terms_seen";

/** The version a sign-up accepted, or null when its screen did not show the notice. */
export function acceptedTermsVersion(
  searchValue: string | null | undefined,
  cookieValue: string | null | undefined,
): string | null {
  return searchValue === TERMS_VERSION || cookieValue === TERMS_VERSION
    ? TERMS_VERSION
    : null;
}
